export default {
  BORGUN: 'borgun',
  VALITOR: 'valitor',
  STRIPE: 'stripe',
};
